/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * Cookieのキー
 */
export const SIGNUP_WITH_RESUME_COOKIE_KEY = 'signup_with_resume';

/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * Cookieの有効期間
 */
export const SIGNUP_WITH_RESUME_COOKIE_TERM = 30;

/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * ABテストの振り分けキー
 */
export const SIGNUP_WITH_RESUME_ABTEST_KEY = 'web1_signup_with_resume';

/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * ABテストの振り分け値
 */
export const SignupWithResumeABTestPattern = {
  Original: 1,
  TestPattern: 2,
} as const;
